import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Link from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import {
  CREATE_ACCOUNT_TEXT,
  CREATE_ACCOUNT_TITLE
} from './constants'

const CreateAccountLink = ({
  registrationLocation
}) => (
  <CreateAccount>
    <Text bolder lineheight={ 1.5 }>
      {CREATE_ACCOUNT_TEXT}&nbsp;
    </Text>
    <Link
      data-at-appointment-create-an-account-btn
      bolder
      to={ registrationLocation }>{CREATE_ACCOUNT_TITLE}</Link>
  </CreateAccount>
)

export default CreateAccountLink

CreateAccountLink.propTypes = {
  registrationLocation: PropTypes.shape()
}

const CreateAccount = styled.div`
  margin-top: 26px;
  padding: 13px 18px;
  line-height: 26px;
  background-color: ${Theme.colors.pale_yellow};
`
